import Flickity from "flickity";
import { isOver } from "../../js/lib/util";
import { createApp, defineComponent } from "vue";

const breakpoint = 767;

export default (el: HTMLElement) => {
  const componentDefinition = defineComponent({
    data() {
      return {
        isMounted: false,
        flickity: null as Flickity | null,
      };
    },
    methods: {
      init() {
        this.$nextTick(() => {
          this.flickity = new Flickity(this.$refs["carousel"] as HTMLElement, {
            cellAlign: "left",
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: true,
            freeScroll: false,
            wrapAround: true,
          });
        });
      },
      destroy() {
        this.flickity?.destroy();
        this.flickity = null;
      },
      onResize() {
        if (!this.flickity) {
          if (!isOver(breakpoint)) this.init();
        } else {
          if (isOver(breakpoint)) this.destroy();
        }
      },
    },
    mounted() {
      this.isMounted = true;

      if (!isOver(breakpoint)) {
        this.init();
      }

      window.addEventListener("resize", () => {
        this.onResize();
      });
    },
  });
  const instanceApp = createApp(componentDefinition as any);
  return instanceApp.mount(el);
};
